/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit IsPastDueDate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'



/** @type {import('Simple/types.js').View} */
export default function IsPastDueDate({
  children,
  viewPath = "/DesignSystem/TasksFilters/IsPastDueDate"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let filtersIsPastDueDateValueData = fromData.useDataValue({ viewPath,
context: 'filters',
path: 'is_past_due_date',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 onClick={onClick}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
 data="filters.is_past_due_date"
 value={filtersIsPastDueDateValueData}
 size="small"
/>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 marginRight={0}
 text="is past due date"
/>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}